export default () => localStorage.getItem('language') ?? 'en';
